import { render } from "./Estimations.vue?vue&type=template&id=25134490&scoped=true"
import script from "./Estimations.vue?vue&type=script&lang=js"
export * from "./Estimations.vue?vue&type=script&lang=js"

import "./Estimations.vue?vue&type=style&index=0&id=25134490&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25134490"]])

export default __exports__